/**
 * Pages that work without a session (locale prefix stripped). /handoff signs in from a token in
 * its own address, so it must work with or without a session cookie.
 */
export const PUBLIC_PATHS: readonly string[] = ["/login", "/handoff"];
